/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - write tests for and refactor if needed
*/

/**
 * Mark Dixon 2019-08-20
 *
 * If certain parameters exist in the URL, set a cookie. This is used for Referral, Adwords, Affiliates tracking. The
 * cookie values are sent to Leadservice (see HiddenFields.php) NOTE: gclid parameter (used for Adwords) has a slightly
 * different logic (conditions).
 */

import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { getParamValueFromUrl } from 'root/utils/URLParams/URLParams';
import data from 'root/core/tracking/trackingCookies/url_parameter_tracking.json';

export default function TrackingCookies() {
    return (function () {
        const url = location.href;
        const urlParameterTracking = data;
        const cookieExpiry = 90;

        const track = (key, name, value, category = 'necessary') => {
            if (key === 'gclid') {
                const gclsrc = getParamValueFromUrl('gclsrc');
                if (gclsrc && !gclsrc.includes('aw')) {
                    return;
                }
            }
            const cm = new CookieMonster({ useDomain: true });

            window.registerCookieComplianceCallback({
                callback: () => cm.setCookie(name, value, cookieExpiry),
                category,
                rejectCallback: () => cm.unsetCookie(name),
            });
        };

        const parse = () => {
            const parameterString = url.split('?')[1];
            urlParameterTracking.forEach(item => {
                const { name, category } = item.cookie;
                const isParamInUrl = item.params.some(param =>
                    parameterString.includes(param)
                );
                if (!isParamInUrl) return;
                const param = item.params.find(param => parameterString.includes(param));
                const value = getParamValueFromUrl(param);
                track(param, name, value, category);
            });
        };

        const init = () => {
            if (url.includes('?') && urlParameterTracking !== 'undefined') parse();
        };

        return {
            init: init,
        };
    })().init();
}
